import { DataProvider, QStack } from '@qualio/ui-components';
import { isDocumentAccount } from '../../../../../api/model/document';
import { resolveActionFilters, resolveStatusFilters } from '../constants';
import { useWorkspaceAccountFilter } from '../hooks/useWorkspaceAccountFilter';
import { WorkspaceTabs } from '../WorkspaceV2';
import {
  AccountFilterField,
  OwnerFilterField,
  TagsFilterField,
  TypesFilterField,
} from '../../../TableFilters';
import { ActionFilter } from './ActionFilter';
import { StatusFilter } from './StatusFilter';

export const getTableParams = (pageParam: DataProvider.PageParams) => {
  const urlParams = pageParam.toUrlSearchParams();
  const { searchTerm } = pageParam;
  const orderBy = urlParams.get('orderBy');
  const template = urlParams.get('types');
  const limit = urlParams.get('limit') ? Number(urlParams.get('limit')) : 15;
  const status = urlParams.get('status');
  const action = urlParams.get('action');
  const offset = urlParams.get('offset') ? Number(urlParams.get('offset')) : 0;
  const tags = urlParams.get('tags');
  const owner = urlParams.get('owner');
  const account = urlParams.get('account');

  const tagsFilter = tags ? tags.split(',') : [];
  const ownerFilter = owner ? Number(owner) : null;
  const accountFilter =
    account && isDocumentAccount(account) ? account : undefined;

  const statusFilters = resolveStatusFilters(status);
  const actionFilters = resolveActionFilters(action);

  const templateFilter = template ? template.split(',') : null;

  return {
    offset,
    limit,
    orderBy,
    searchTerm,
    statusFilters,
    actionFilters,
    templateFilter,
    tagsFilter,
    ownerFilter,
    accountFilter,
  };
};

export const TableFilter = ({ tab }: { tab: WorkspaceTabs }) => {
  const { parentCompanyName } = useWorkspaceAccountFilter(tab);

  return (
    <QStack spacing={4} direction="column">
      {tab !== WorkspaceTabs.YOUR_ACTIONS && <StatusFilter />}
      {tab === WorkspaceTabs.YOUR_ACTIONS && <ActionFilter />}
      <OwnerFilterField name="owner" dataCy="workspace-owner-filter" />
      <TagsFilterField name="tags" dataCy="workspace-tags-filter" />
      <TypesFilterField
        name="types"
        dataCy="workspace-template-filter"
        includeArchived={false}
      />
      {parentCompanyName && (
        <AccountFilterField
          name="account"
          dataCy="workspace-account-filter"
          parentCompanyName={parentCompanyName}
        />
      )}
    </QStack>
  );
};
